require('../../modules/es.array.includes');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'includes');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/es/array/includes.js
// module id = 707
// module chunks = 1